import { createIcon } from "@chakra-ui/react";

export const Magnifier = createIcon({
  displayName: "Magnifier",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm6.5-5.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
    />,
    <path
      fill="currentColor"
      d="M14.344 15.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"
    />,
  ],
  defaultProps: {
    "aria-label": "A magnifying glass"
  }
});

export default Magnifier;
